import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RequestError } from '../../../interfaces/error.interface';
import { User } from '../../../interfaces/user.interface';
import { Company } from '../../../interfaces/company.interface';

export interface MeState {
  user: User | null;
  companies: Company[];
  errorCode: number | null;
}

const initialState: MeState = {
  user: null,
  companies: [],
  errorCode: null,
};

const meSlice = createSlice({
  name: 'me',
  initialState,
  reducers: {
    getMeUserInitApiAction: (state) => {
      state.errorCode = null;
    },
    getMeUserSuccessApiAction: (
      state,
      action: PayloadAction<User>
    ) => {
      state.user = action.payload;
    },
    getMeUserFailureApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    putMeUserInitApiAction: (state) => {
      state.errorCode = null;
    },
    putMeUserSuccessApiAction: () => {},
    putMeUserFailureApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    getMeCompaniesInitApiAction: (state) => {
      state.errorCode = null;
    },
    getMeCompaniesSuccessApiAction: (
      state,
      action: PayloadAction<Company[]>
    ) => {
      state.companies = action.payload;
    },
    getMeCompaniesFailureApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    putMePasswordInitApiAction: (state) => {
      state.errorCode = null;
    },
    putMePasswordSuccessApiAction: () => {},
    putMePasswordFailureApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    meClearAction: (state) => {
      state.user = null;
      state.companies = [];
      state.errorCode = null;
    },
  },
});

export const {
  getMeUserInitApiAction,
  getMeUserSuccessApiAction,
  getMeUserFailureApiAction,
  putMeUserInitApiAction,
  putMeUserSuccessApiAction,
  putMeUserFailureApiAction,
  getMeCompaniesInitApiAction,
  getMeCompaniesSuccessApiAction,
  getMeCompaniesFailureApiAction,
  putMePasswordInitApiAction,
  putMePasswordSuccessApiAction,
  putMePasswordFailureApiAction,
  meClearAction,
} = meSlice.actions;

export default meSlice.reducer;
